import { Box, Container } from "@mui/material";
import React from "react";
import { Trading } from "../../CommonPage/MarketFlow/Trading";
import GlobalAssets from "../../Componenets/Globalassets/GlobalAssets";
import WhyTradeForex from "../../CommonPage/WhyTradeForexs/WhyTradeForex";
import { PickPairs } from "../../CommonPage/PickPair/PickPairs";
import { PickPairsStock } from "../../CommonPage/PickPair/PickPairsStock";
import Wealth from "../../Componenets/Globalassets/Wealth";
import NewWealth from "../../Componenets/Globalassets/NewWealth";
import { useLanguage } from "../../context/LanguageContext";
import GlobalStocks from "../../Componenets/Globalassets/GlobalStocks";

export const StockDerivatives = () => {
  const { language, translations } = useLanguage();

  const Commonity = [
    { name: "NTFX", spread: "1.2",img:"Images/netFlix.png", leverage: "1:100", lowSpread: "35:65",sub:"Netflix (NTFX.OQ)" },
    { name: "Apple", spread: "1.4",img:"Images/Appless.png", leverage: "1:100", lowSpread: "35:65",sub:"Apple (AAPL.OQ)" },
    { name: "TSLA", spread: "1.1",img:"/Images/four10.png",leverage: "1:100", lowSpread: "35:65",sub:"Tesla (TSLA.OQ)" },
    { name: "NVDA", spread: "1.2",img:"/Images/greeeen.png",leverage: "1:100", lowSpread: "35:65",sub:"NVIDIA (NDVA.OQ)" },
    { name: "GOOGL", spread: "1.4",img: "/Images/four2.png", leverage: "1:100", lowSpread: "35:65",sub:"Google (GOOGL.OQ)" },
    { name: "MSFT", spread: "1.1",img: "/Images/four5.png", leverage: "1:100", lowSpread: "35:65",sub:"Microsoft (MSFT.OQ)" },
    { name: "COLA", spread: "1.2",img:"Images/cola.png", leverage: "1:100", lowSpread: "35:65",sub:"Coco Cola (Cola.OQ)" },
    { name: "NIKE", spread: "1.2",img:"Images/nike.png", leverage: "1:100", lowSpread: "35:65",sub:"Nike (Nike.OQ)" },
    { name: "AMZN", spread: "1.2",img:"/Images/four7.png", leverage: "1:100", lowSpread: "35:65",sub:"Amazon (AMZN.OQ)" },
    { name: "META", spread: "1.2",img:"/Images/four4.png", leverage: "1:100", lowSpread: "35:65",sub:"Meta (Meta.OQ)" },
  ];
    const cardData = [
        {
          heading:translations[language]?.cardDataEncosts?.title1,
          logo: "/Images/stock1.png",
          description:
          translations[language]?.cardDataEncosts?.description1,
        },
        {
          heading:translations[language]?.cardDataEncosts?.title2,
          logo: "/Images/stock2.png",
          description:
          translations[language]?.cardDataEncosts?.description2,
        },
        {
          heading:translations[language]?.cardDataEncosts?.title3,
          logo: "/Images/stock4.png",
          description:
          translations[language]?.cardDataEncosts?.description3,
        },
        {
          heading:translations[language]?.cardDataEncosts?.title4,
          logo: "/Images/stock3.png",
          description:
          translations[language]?.cardDataEncosts?.description4,
        },
      ];

  return (
    <Box>
      <Trading banner="Images/forexClean2.png" titleLine1={translations[language]?.tradingNew1?.titleLine1} active={translations[language]?.tradingNew1?.active} titleLine2={translations[language]?.tradingNew1?.titleLine2} subtitle={translations[language]?.tradingNew1?.subtitle} />
      <GlobalStocks />
      <WhyTradeForex  cardData={cardData}/>
      <PickPairsStock Commonity={Commonity} title={translations[language]?.derivate} subtitle={translations[language]?.desDerivate} />
    
        <Box mt={10} mx={3}>
          <NewWealth />
        </Box>
       
      
    </Box>
  );
};
// 